import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '@/components/Common/PageHeader'
import SEOHead from '@/components/SEO/SEOHead'
import { buildGraph, breadcrumbListData, webPageSchema } from '@/data/structured-data'
import { motion } from 'framer-motion'
import { Dog, Cat } from 'lucide-react'

const DiseasesIndex: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Hastalık Rehberi | Ardıç Veteriner Kliniği"
        description="Kedi ve köpek hastalıkları rehberi: belirtiler, tedavi yaklaşımları ve korunma yolları. Şanlıurfa Karaköprü Ardıç Veteriner Kliniği tarafından hazırlandı."
        keywords="kedi hastalıkları, köpek hastalıkları, hayvan sagligi, kedi iç parazit, köpek aşı takvimi, kedi ilk aşıları, hayvan tedavisi"
        canonicalUrl="/hastaliklari"
        structuredData={buildGraph(
          webPageSchema({
            name: 'Hastalık Rehberi',
            description: 'Kedi ve köpek hastalıkları hakkında belirtiler, tedavi ve korunma bilgileri.',
            url: '/hastaliklari',
            type: 'CollectionPage'
          }),
          breadcrumbListData([
            { name: 'Ana Sayfa', url: '/' },
            { name: 'Hastalık Rehberi', url: '/hastaliklari' }
          ])
        )}
      />
      <PageHeader title="Hastalık Rehberi" subtitle="Kedi ve köpek hastalıkları hakkında bilgilendirici içerikler." />
      <section className="section-padding">
        <div className="container-custom grid grid-cols-1 md:grid-cols-2 gap-6">
          <motion.div initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} whileHover={{y:-4}} className="bg-gradient-to-br from-primary-50 via-white to-accent-50 rounded-2xl border p-6 shadow">
            <Link to="/hastaliklari/kopek" className="block">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 rounded-lg bg-primary-100"><Dog className="w-5 h-5 text-primary-700"/></div>
                <h3 className="text-lg font-bold">Köpek Hastalıkları</h3>
              </div>
              <p className="text-gray-600 text-sm">Aşıyla önlenebilir hastalıklar, sindirim, deri ve solunum sistemi sorunları hakkında kısa ve anlaşılır bilgiler.</p>
            </Link>
          </motion.div>

          <motion.div initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} whileHover={{y:-4}} className="bg-gradient-to-br from-primary-50 via-white to-accent-50 rounded-2xl border p-6 shadow">
            <Link to="/hastaliklari/kedi" className="block">
              <div className="flex items-center gap-3 mb-2">
                <div className="p-2 rounded-lg bg-primary-100"><Cat className="w-5 h-5 text-primary-700"/></div>
                <h3 className="text-lg font-bold">Kedi Hastalıkları</h3>
              </div>
              <p className="text-gray-600 text-sm">Viral hastalıklar, alt üriner sistem problemleri ve solunum yolu enfeksiyonları için pratik rehber.</p>
            </Link>
          </motion.div>
        </div>
      </section>
    </>
  )
}

export default DiseasesIndex


